import { Avatar, Button, IconButton, Typography } from "@mui/material";
import { HeaderVarianInterface, HeaderVariant } from "../header-varian";
import Scroll from 'react-scroll';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

import './style.css';
import { useEffect, useState } from "react";
import { useIsMobileMediaQuery } from "@common/utils/hooks/is-mobile-media-query";
import { useCompactLayout } from "@app/hooks/BiolinkPageHooks";
import { KeyboardDoubleArrowRightIcon } from "@common/icons/material/KeyboardDoubleArrowRight";
import { KeyboardDoubleArrowLeftIcon } from "@common/icons/material/KeyboardDoubleArrowLeft";

export interface BasicConfig extends HeaderVarianInterface {
    config: {
        'avatar': string,
        'title': string,
        'description': string,
    };
    variant: string
}

export default function BasicReader(props: BasicConfig) {
    const isMobile = useIsMobileMediaQuery();

    return (
        <div className="flex justify-center items-center flex-col mt-24">
            <img
                src={props.config.avatar}
                alt={props.config.title}
                className="mb-12"
                style={{
                    width: "115px",
                    backgroundColor: "#fff",
                    height: "115px",
                    borderRadius: "50%",
                    border: "4px solid white",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
            />
            <>
                <Typography variant="h5" sx={{
                    fontWeight: 600,
                }}>
                    {props.config.title}
                </Typography>
                <Typography variant="subtitle1" sx={{
                    fontWeight: 80
                }}>
                    {props.config.description}
                </Typography>
            </>
        </div>
    );
}